import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

export default function EditorialSectionActionButton({ label, onClick, variant = 'ghost', className = '' }) {
  if (!label) return null;
  const accentClass = variant === 'accent'
    ? 'band-schedule__btn--accent'
    : 'band-schedule__btn--ghost';
  return (
    <button
      type="button"
      className={classNames('band-schedule__btn', accentClass, className)}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

EditorialSectionActionButton.propTypes = {
  label: PropTypes.node,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['accent', 'ghost']),
  className: PropTypes.string,
};
